import { TYPES } from "../actions/nextPresentationAction.js";

const {
  API_REQUEST,
  API_ERROR,
  API_SUCCESS,
  CLEAR_ERROR,

  CONFIGURE_PRESENTATION_SUCCESS,
  CREATE_PRESENTATION_SUCCESS,
  UPDATE_PRESENTATION_SUCCESS,
  LIST_PRESENTATION_SUCCESS,
  SHARE_PRESENTATION_SUCCESS,

  CREATE_KEYMESSAGE_SUCCESS,
  UPDATE_KEYMESSAGE_SUCCESS,
  LIST_KEYMESSAGE_SUCCESS,
  UPDATE_BULK_KEYMESSAGE_SUCCESS,

  DELETE_PRESENTATION,
  DELETE_KEYMESSAGE,
  USER_LIST,
  RESET_KM_LOADER,
} = TYPES;

const initialState = {
  loading: true,
  presentationError: "",
  presentations: [],
  keyMessages: [],
  users: [],
  error: false,
  msg: null,
};

const nextPresentationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        error: false,
        msg: null,
      };

    case CREATE_PRESENTATION_SUCCESS:
      let tempPresentation = state.presentations;
      if (action.data) {
        tempPresentation = [action.data, ...state.presentations];
      }
      return {
        ...state,
        presentations: tempPresentation,
        loading: false,
        msg: action.msg || "Presentation created successfully",
      };

    case CONFIGURE_PRESENTATION_SUCCESS:
      return {
        ...state,
        presentations: state.presentations.map((pres) => {
          if (pres._id !== action.data._id) return pres;
          else return action.data;
        }),
        loading: false,
        msg: action.msg || "Presentation configured successfully",
      };

    case SHARE_PRESENTATION_SUCCESS:
      const allPresn = [...state.presentations];
      const newPresn = allPresn.map((p) => (p._id === action.data.pId ? { ...p, sharedWith: action.data.sharedWithData } : p));
      return {
        ...state,
        presentations: newPresn,
        msg: "Share Presenation is updated successfully!!",
      };

    case UPDATE_PRESENTATION_SUCCESS:
      const allPres = [...state.presentations];
      const newPres = allPres.map((p) => (p._id === action.data.pId ? { ...p, name: action.data.name } : p));
      return {
        ...state,
        presentations: newPres,
        msg: "Presentaion updated successfully",
      };

    case LIST_PRESENTATION_SUCCESS:
      return {
        ...state,
        presentations: action.data,
        loading: false,
      };

    case CREATE_KEYMESSAGE_SUCCESS:
      return {
        ...state,
        keyMessages: [...state.keyMessages, action.data],
        loading: false,
        error: false,
        msg: "Key Message created successfully",
      };

    case UPDATE_KEYMESSAGE_SUCCESS:
      const allKMs = [...state.keyMessages];
      const newKMs = allKMs.map((km) =>
        km._id === action.data.kmId && km.presentation[0] === action.data.pId ? { ...km, name: action.data.name } : km
      );
      return {
        ...state,
        keyMessages: newKMs,
        error: false,
        msg: "Key message updated successfully",
      };
    case LIST_KEYMESSAGE_SUCCESS:
      return {
        ...state,
        keyMessages: action.data,
        loading: false,
        kmLoader: false,
      };
    case UPDATE_BULK_KEYMESSAGE_SUCCESS:
      return {
        ...state,
        keyMessages: action.data,
        msg: "Bulk update completed.",
        error: false,
      };

    case DELETE_PRESENTATION:
      let presentations = [...state.presentations];

      return {
        ...state,
        presentations: presentations.filter((p) => p._id !== action.data),
        loading: false,
        msg: "Presentation deleted successfully",
      };

    case DELETE_KEYMESSAGE:
      let keyMessages = [...state.keyMessages];

      return {
        ...state,
        keyMessages: keyMessages.filter((p) => {
          return p._id !== action.data.kmId || p.presentation !== action.data.pId;
        }),
        loading: false,
        error: false,
        msg: "Key message deleted successfully",
      };

    case API_REQUEST:
      return { ...state, loading: true };

    case API_ERROR:
      return {
        ...state,
        presentationError: action.data,
        loading: false,
        error: true,
        msg: action.data,
      };

    case API_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        msg: action.data || "Success",
      };

    case USER_LIST:
      return {
        ...state,
        loading: false,
        users: action.data,
      };

    case RESET_KM_LOADER:
      return {
        ...state,
        kmLoader: true,
      };

    default:
      return state;
  }
};

export default nextPresentationReducer;
